import { OptionsControl } from './options.model';
import { BaseControl } from '@app/shared/dynamic-form/shared/controls/base-control';

interface OptionsDateTimePicker extends OptionsControl<Date> {
    // define el tipo de picker
    // tipos: calendario: 'calendar', tiempo: 'timer'
    // Nota: para utilizar ambos no es necesario utilizar esta propiedad
    pickerType: string;
    // define el modo del picker en modal o lineal
    // tipos: modal: 'dialog'
    // Nota: para mostrar el picker de forma lineal no es necesaria eta propiedad
    pickerMode: string;
    // define la seleccion del picker, solo un afecha o rango
    // tipos: rango: 'range'
    // Nota: solo en caso de necesitarse un rango
    selectMode: string;
    // fecha en la que se desea que al abrir el picker se encuentre
    startView: Date;
    // fecha maxima a ingresar
    maxDate: Date;
    // fecha minima a ingresar
    minDate: Date;
    // Activar input
    inputActive: boolean;
}

export class DateTimePicker extends BaseControl<Date> implements OptionsDateTimePicker {
    controlType = 'datetimepicker';
    pickerType: string;
    pickerMode: string;
    selectMode: string;
    startView: Date;
    maxDate: Date;
    minDate: Date;
    inputActive: boolean;

    constructor(options: Partial<OptionsDateTimePicker>) {
        super(options);
        this.pickerType = options.pickerType || 'both';
        this.pickerMode = options.pickerMode || 'popup';
        this.startView = options.startView || new Date();
        this.maxDate = options.maxDate || new Date(2038, 12, 31);
        this.minDate = options.minDate || new Date(1970, 1, 1);
        this.selectMode = options.selectMode || 'single';
        this.inputActive = options.inputActive || false;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/dynamic-form/shared/controls/datetimepicker.ts